import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { Assets } from '@/types';
import selectors from '@/ui/flux/selectors';
import useConversion from '@/ui/hooks/use-conversion';
import getAssetFromCurrency from '../../utils/get-asset-from-currency.js';

const useConvertedAmount = ({ amount }) => {
  const assets = useSelector(selectors.assets.all) as Assets;
  const asset = amount ? getAssetFromCurrency({ amount, assets }) : null;
  const assetConversion = useConversion(asset?.name);
  return useMemo(
    () => (amount ? assetConversion(amount) : null),
    [amount, assetConversion],
  );
};

export default useConvertedAmount;
